document.addEventListener('DOMContentLoaded', function () {

    const stepSection = document.querySelector('.step-main-section');

    if (!stepSection) {
        return;
    }

    const app = document.querySelector('.jt-app.step-main-section');
    if (!app) return;
    const navItems = app.querySelectorAll('.step-nav-item');
    const catWrap = app.querySelector('.category-wrapper');
    const cats = app.querySelectorAll('.jt-cat');
    const backBtn = app.querySelector('.jt-back');
    const appForm = app.querySelector('.jt-app-form');
    const mainHeading = app.querySelector('.jt-heading');
    const mainNextBtn = app.querySelector('.main-next-btn');
    let currentStep = -1;
    if (cats.length > 0) {
        cats[0].classList.add('active');
    }
    if (appForm) appForm.style.display = 'none';
    function updateNavDots(stepIndex) {
        navItems.forEach((item, i) => {
            item.classList.remove('active', 'completed');
            if (i === stepIndex) {
                item.classList.add('active');
            } else if (i < stepIndex) {
                item.classList.add('completed', 'active');
            }
        });
    }
    function updateStepsUI() {
        if (currentStep === -1) {
            catWrap.style.display = 'block';
            appForm.style.display = 'none';
            if (mainHeading) mainHeading.style.display = 'block';
            if (backBtn) backBtn.style.display = 'none';
            updateNavDots(0);
        } else {
            catWrap.style.display = 'none';
            appForm.style.display = 'block';
            if (mainHeading) mainHeading.style.display = 'none';
            if (backBtn) backBtn.style.display = 'flex';
        }
    }
    cats.forEach((cat) => {
        cat.addEventListener('click', function () {
            cats.forEach((c) => c.classList.remove('active'));
            this.classList.add('active');
        });
    });
    if (mainNextBtn) {
        mainNextBtn.addEventListener('click', function () {
            const activeCat = document.querySelector('.jt-cat.active');
            if (activeCat) {
                currentStep = 0;
                updateStepsUI();
                updateNavDots(1);
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        });
    }
    if (backBtn) {
        backBtn.addEventListener('click', function () {
            const embed = document.querySelector('shopify-forms-embed');
            if (embed && embed.shadowRoot) {
                const shadow = embed.shadowRoot;
                const step2 = shadow.querySelector('.step-2-wrapper');
                const step3 = shadow.querySelector('.step-3-wrapper');
                const heading = shadow.querySelector('h2');
                const headerContainer =
                    shadow.querySelector('._formHeader_z5ku3_1') || (heading ? heading.parentElement : null);
                if (step3 && window.getComputedStyle(step3).display !== 'none') {
                    step3.style.setProperty('display', 'none', 'important');
                    step2.style.setProperty('display', 'grid', 'important');
                    if (headerContainer) {
                        headerContainer.style.setProperty('display', 'block', 'important');
                        headerContainer.style.setProperty('visibility', 'visible', 'important');
                        headerContainer.style.setProperty('opacity', '1', 'important');
                    }
                    if (heading) {
                        heading.innerText = 'Share your design details';
                        heading.style.setProperty('display', 'block', 'important');
                        heading.style.setProperty('visibility', 'visible', 'important');
                    }
                    const subText = shadow.querySelector('._textBody_2aowh_10') || shadow.querySelector('p');
                    if (subText) {
                        subText.style.setProperty('display', 'none', 'important');
                    }
                    updateNavDots(1);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                    return;
                }
                if (step2 && window.getComputedStyle(step2).display !== 'none') {
                    currentStep = -1;
                    updateStepsUI();
                    updateNavDots(0);
                    return;
                }
            }
            currentStep = -1;
            updateStepsUI();
        });
    }
    function initObserver() {
        const embed = document.querySelector('shopify-forms-embed');
        if (!embed || !embed.shadowRoot) return;
        const shadow = embed.shadowRoot;
        const observer = new MutationObserver(() => {
            const step2 = shadow.querySelector('.step-2-wrapper');
            const step3 = shadow.querySelector('.step-3-wrapper');
            const successBanner = shadow.querySelector('[data-testid="banner-success"]');
            const successMsg = shadow.querySelector('._formBannerContainer_z5ku3_1');
            if (successBanner || successMsg) {
                updateNavDots(3);

                if (backBtn) {
                    backBtn.style.display = 'none';
                }

                window.scrollTo(0, 0);

                return;
            }
            if (currentStep >= 0) {
                if (step3 && window.getComputedStyle(step3).display !== 'none') {
                    updateNavDots(2);
                } else if (step2 && window.getComputedStyle(step2).display !== 'none') {
                    updateNavDots(1);
                }
            }
        });
        observer.observe(shadow, {
            attributes: true,
            subtree: true,
            childList: true,
            attributeFilter: ['style', 'class'],
        });
    }
    const checkEmbed = setInterval(() => {
        const embed = document.querySelector('shopify-forms-embed');
        if (embed && embed.shadowRoot) {
            initObserver();
            clearInterval(checkEmbed);
        }
    }, 500);
    updateStepsUI();


    //App
    function initShopifyFormFix() {
        const host = document.querySelector('shopify-forms-embed');
        if (!host || !host.shadowRoot) return;
        const shadow = host.shadowRoot;
        if (shadow.querySelector('#custom-form-style')) return;
        const style = document.createElement('style');
        style.id = 'custom-form-style';
        style.innerHTML = `
            .custom-placeholder::before {
              content: "Select option";
              color: #20202080;
              position: absolute;
              pointer-events: none;
            }
            .has-value::before {
              display: none !important;
            }
            ._selectContainer_12thd_6:nth-child(7){
              grid-column: 1/ -1;
            }
            ._dropdownContainer_12thd_63,
            ._optionList_12thd_86{
              max-height: 309px !important;
              min-height: 309px; !important;
              height: 100% !important;
            }
            ._dropdownContainer_12thd_63{
              overflow-y: hidden !important;
            }
            ._optionList_12thd_86{
              padding: 15px 10px !important;
            }
            ._selectToggleText_12thd_25{
              position: relative;
              display: block;
              min-height: 1.2em;
            }
            ._selectToggleText_12thd_25:empty::before{
              content: "Select option";
              color: #20202080;
              position: absolute;
              left: 0;
            }
            ._selectContainer_12thd_6,
            ._formFileInput_ehvsf_1,
            .column-div{
              text-align: left !important;
            }
            form._formFieldset_cit2d_82 {
              display: grid !important;
              grid-template-columns: 1fr 1fr !important;
              row-gap: 16px !important;
              column-gap: 30px !important;
            }
            ._formFieldset_cit2d_82 > div:first-child {
              grid-column: 1 / -1 !important;
            }
            ._formFileInput_ehvsf_1, 
            ._formSubmitButton_cit2d_96,
            ._formFieldset_cit2d_82 > div:nth-child(9){
                grid-column: 1 / -1 !important;
                text-align: left !important;
            }
            ._formFieldset_cit2d_82 > div:nth-child(10) ._textBody_2aowh_10{
              display: none;
            }
            ._formSubmitButton_cit2d_96{
                margin-top: 20px;
            }
            ._formFieldContainer_1mxsl_5{
              display: flex !important;
              flex-direction: column !important;
              position: relative !important;
              padding-top: 22px !important; 
            }
            ._formFileInput_ehvsf_1 ._textBody_2aowh_10{
              display: none;
            }
            label._formInputFieldLabel_1mxsl_38{
              position: absolute !important;
              top: 0 !important;
              left: 0 !important;
              transform: none !important;
              font-size: 16px !important;
              font-weight: 500 !important;
              color: #000 !important;
              display: block !important;
            }
            input._formInputField_nag3b_7::placeholder{
              color: #20202080 !important;
              opacity: 1 !important;
              visibility: visible !important;
            }
            section._formHeader_cit2d_24{
              margin: 5px auto 60px !important;
            }
            input._formInputField_nag3b_7{
              padding: 13px 15px  !important;
            }
            input._formInputField_1quli_7{
                padding-top:15px !important;
                padding-bottom:15px !important;
            }
            ._formFieldContainer_1mxsl_5 textarea{
              padding: 15px !important;
            }
            ._formFieldContainer_1mxsl_5:has(textarea)::before{
              background-color: transparent !important;
            }
            ._formFileInputField_ehvsf_5 {
              display: flex !important;
              flex-direction: column !important;
              align-items: center !important;
              justify-content: center !important;
              padding: 40px !important;
              margin-top: -20px !important;
            }
            .next-step-btn ,
            button._formSubmitButton_cit2d_96{
              grid-column: 1 / -1 !important;
              max-width: fit-content !important;
              width: 100% !important;
              padding: 16px 32px !important;
              text-transform: uppercase !important;
              letter-spacing: 3px !important;
              margin: 20px auto 0 auto !important;
              display: block !important;
              background: #4B3E37; 
              color: #fff;
              border: none;
              cursor: pointer;
              min-width: 200px !important;
              text-align: center !important;
              display: flex !important;
              align-items: center !important;
              justify-content: center !important;
              border-radius: 0px !important;
            }
            ._formFileInputField_ehvsf_5::before {
                display: none !important;
            }
            ._formFileInputButton_ehvsf_18 {
               line-height: 1 !important;
            }
            ._formFileInputButton_ehvsf_18::after {
                content: "Drop your inspirational photos here or Upload" !important;
                font-size: 18px !important;
                color: #000000 !important;
                font-weight: 400 !important;
                display: block !important;
                margin-bottom: 5px !important;
            }
            ._formFileInputField_ehvsf_5::after {
                content: "Max 20 MB per image" !important;
                font-size: 14px !important;
                color: #808080 !important;
                display: block !important;
            }
            ._formFileInputButton_ehvsf_18 {
                font-size: 0 !important;
                background-color: transparent !important;
            }
            h2._textHeading_2aowh_35{
                margin-bottom: 60px !important;
                padding: 0 15px;
                font-size: 40px !important;
                font-family: PP Editorial New !important;
                line-height: 1.2 !important;
            }
            .step-3-wrapper{
               display: none;
               grid-template-columns: 1fr !important; 
               gap: 20px !important;
               width: 100% !important;
            }
            ._textBody_2aowh_10 {
              font-size: 16px !important;
              color: #202020 !important;
              margin-top: -40px !important; 
              margin-bottom: 30px !important;
            }
            ._formDisclaimer_cit2d_38 p{
              font-size: 16px !important;
            }
            ._formDisclaimer_cit2d_38 {
                cursor: pointer !important;
                text-decoration: underline !important;
                text-align: center !important;
                margin-top: 15px !important;
                color: #4B3E37 !important;
                display: block !important;
            }
            .final-skip-step {
                display: none; 
                text-align: center;
                grid-column: 1 / -1;
                padding: 30px 20px;
                border: 1px solid #eee;
                background: #fdfdfd;
                margin-top: -20px;
            }
            .final-skip-step p { 
                margin-bottom: 20px; 
                font-size: 16px;
                color: #000;
            }
            ._formBannerHeading_z5ku3_9{
                font-size: 40px !important;
                font-family: PP Editorial New !important;
                margin-bottom: 20px !important;
                color: #4b3a36 !important;
            }
            .progress-bar {
              width: 100%;
              height: 6px;
              background: #eeeeeed0;
              box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
              overflow: hidden;
              border-radius: 50px;
              margin-top: 5px;
            }
            .progress-fill {
              height: 100%;
              width: 0%;
              background: repeating-linear-gradient(
                45deg,
                #4b3a36d7,
                #4b3a36d7 10px,
                #80746f 10px,
                #80746f 20px
              );
              transition: width 2s ease-in-out; 
            }
            ._formFileInputFileName_ehvsf_34 {
                display: grid !important;
                grid-template-columns: 50px 1fr 30px !important; 
                grid-template-rows: auto auto !important; 
                align-items: center !important;
                gap: 10px !important;
                row-gap: 7px !important; 
                background: #f9f9f9 !important;
                padding: 10px !important;
                border-radius: 8px !important;
                margin: 0px !important;
                border: 1px solid #eee !important;
                width: 100% !important;
                box-sizing: border-box !important;
            }
            .custom-img-preview {
                grid-row: 1 / span 2 !important; 
                width: 50px !important;
                height: 50px !important;
                object-fit: cover !important;
                border-radius: 4px !important;
                border: 1px solid #ccc !important;
                margin: 0px 12px 0px 0px !important;
            }
            ._formFileInputFileName_ehvsf_34 > span:first-of-type {
                grid-column: 2 !important;
                font-weight: 500 !important;
                font-size: 14px !important;
                color: #333 !important;
                text-align: left !important;
                margin: 10px 0px 0px 9px;
            }
            .progress-bar-container {
                grid-column: 2 / 4 !important;
                width: 100% !important;
                grid-row: 2 / -2;
            }
            ._formFileInputCancelButton_ehvsf_42 {
                grid-column: 3 !important;
                grid-row: 1 / span 2 !important;
                margin-left: auto !important;
            }
            ._formFileInputField_ehvsf_5.hide-after::after {
                display: none !important;
                content: none !important;
            }
            @media screen and (max-width: 767px){
              form._formFieldset_cit2d_82 {
                  column-gap: 16px !important;
              }
              ._formFileInputField_ehvsf_5{
                padding: 25px !important;
              }
              ._inline_1q1d2_47 ._formContainer_1q1d2_30,
              .step-3-wrapper{
                max-width: 100% !important;
                width: 100% !important;
              }
            }
            @media screen and (max-width: 600px){
              .step-2-wrapper {
                 grid-template-columns: 1fr !important;
                 row-gap: 16px !important;
              }
              h2._textHeading_2aowh_35{
                margin-bottom: 40px !important;
              }
              ._gridItemContent_1q1d2_257{
                padding-top: 40px !important;
              }
            }
            @media screen and (max-width: 400px){
                ._formFileInputField_ehvsf_5 {
                    padding: 20px !important;
                }
            }
              `;
        shadow.appendChild(style);
        const successObserver = new MutationObserver(() => {
            const successMessage =
                shadow.querySelector('[data-testid="banner-success"]') ||
                shadow.querySelector('._formBannerContainer_z5ku3_1');
            if (successMessage) {
                const navItems = document.querySelectorAll('.step-nav-item');
                navItems.forEach((item, index) => {
                    item.classList.add('active');
                    if (index < 3) item.classList.add('completed');
                });
                const mainBackBtn = document.querySelector('.jt-back');
                if (mainBackBtn) mainBackBtn.style.display = 'none';
            }
        });
        successObserver.observe(shadow, { childList: true, subtree: true });
        const fileListObserver = new MutationObserver(() => {
            const host = document.querySelector('shopify-forms-embed');
            if (!host || !host.shadowRoot) return;
            const shadow = host.shadowRoot;

            const fileItems = shadow.querySelectorAll('._formFileInputFileName_ehvsf_34');
            const uploadField = shadow.querySelector('._formFileInputField_ehvsf_5');
            const fileInput = shadow.querySelector('input[type="file"]');

            if (uploadField) {
                if (fileItems.length > 0) {
                    uploadField.classList.add('hide-after');
                } else {
                    uploadField.classList.remove('hide-after');
                }
            }
            fileItems.forEach((container, index) => {
                const file = fileInput?.files[index];
                if (!file) return;
                if (file.type.startsWith('image/')) {
                    let img = container.querySelector('.custom-img-preview');
                    if (!img) {
                        const reader = new FileReader();
                        reader.onload = (e) => {
                            if (!container.querySelector('.custom-img-preview')) {
                                const newImg = document.createElement('img');
                                newImg.className = 'custom-img-preview';
                                newImg.src = e.target.result;
                                newImg.style.cssText = 'width: 40px; height: 40px; object-fit: cover; border-radius: 4px; margin-right: 10px;';
                                container.prepend(newImg);
                            }
                        };
                        reader.readAsDataURL(file);
                    }
                }
                if (!container.querySelector('.progress-bar-container')) {
                    const progressCont = document.createElement('div');
                    progressCont.className = 'progress-bar-container';
                    progressCont.style.width = '100%';
                    progressCont.innerHTML = `
                  <div class="progress-bar">
                      <div class="progress-fill"></div>
                  </div>`;
                    const cancelBtn = container.querySelector('._formFileInputCancelButton_ehvsf_42');
                    if (cancelBtn) {
                        container.insertBefore(progressCont, cancelBtn);
                    } else {
                        container.appendChild(progressCont);
                    }

                    const fill = progressCont.querySelector('.progress-fill');

                    setTimeout(() => {
                        if (fill) fill.style.width = '100%';
                    }, 100);

                    fill.addEventListener('transitionend', () => {
                        setTimeout(() => {
                            progressCont.style.transition = 'opacity 0.5s ease';
                            progressCont.style.opacity = '0';
                            setTimeout(() => {
                                progressCont.style.display = 'none';
                            }, 500);
                        }, 400);
                    });
                }
            });
        });
        const startObserving = () => {
            const host = document.querySelector('shopify-forms-embed');
            if (host && host.shadowRoot) {
                fileListObserver.observe(host.shadowRoot, { childList: true, subtree: true });
            } else {
                setTimeout(startObserving, 500);
            }
        };
        startObserving();
        function wrapErrorFields(shadow) {
            const errors = shadow.querySelectorAll('output._formError_1mxsl_21');
            errors.forEach((error) => {
                if (error.parentElement && error.parentElement.classList.contains('column-div')) return;
                const field = error.previousElementSibling;
                if (field && field.classList.contains('_formFieldContainer_1mxsl_5')) {
                    const wrapper = document.createElement('div');
                    wrapper.className = 'column-div';
                    field.parentNode.insertBefore(wrapper, field);
                    wrapper.appendChild(field);
                    wrapper.appendChild(error);
                }
            });
        }
        setTimeout(() => {
            const fName =
                shadow.querySelector('input#first-name') ||
                shadow.querySelector('input[name="first_name"]') ||
                shadow.querySelector('input[autocomplete="given-name"]') ||
                shadow.querySelector('._formInputField_nag3b_7');
            if (fName) {
                fName.placeholder = 'Enter first name';
                fName.setAttribute('placeholder', 'Enter first name');
                console.log('First Name Placeholder Set!');
            }
            const emailF =
                shadow.querySelector('input#email') ||
                shadow.querySelector('input[name="email"]') ||
                shadow.querySelector('input[type="email"]');
            if (emailF) {
                emailF.placeholder = 'Enter Email';
                emailF.setAttribute('placeholder', 'Enter Email');
            }
            const commentField =
                shadow.querySelector('textarea[name="custom#comments"]') ||
                shadow.querySelector('textarea._textArea_17mgw_1');
            if (commentField) {
                commentField.placeholder = 'Write your comment here...';
                commentField.setAttribute('placeholder', 'Tell us something about it...');
            }
        }, 0);
        const form = shadow.querySelector('form');
        if (form) {
            const step2Wrapper = document.createElement('div');
            step2Wrapper.className = 'step-2-wrapper';
            step2Wrapper.style.display = 'grid';
            step2Wrapper.style.gridTemplateColumns = '1fr 1fr';
            step2Wrapper.style.gap = '16px 30px';
            step2Wrapper.style.gridColumn = '1 / -1';
            const step3Wrapper = document.createElement('div');
            step3Wrapper.className = 'step-3-wrapper';
            step3Wrapper.style.display = 'none';
            step3Wrapper.style.gridColumn = '1 / -1';
            step3Wrapper.style.width = '100%';
            const step1Fields = [
                shadow.querySelector('#first_name')?.closest('._formFieldContainer_1mxsl_5'),
                shadow.querySelector('#email')?.closest('._formFieldContainer_1mxsl_5'),
                ...Array.from(shadow.querySelectorAll('._selectContainer_12thd_6')),
            ].filter((el) => el !== null);
            const uploadDiv = shadow.querySelector('._formFileInput_ehvsf_1');
            const commentTextarea =
                shadow.querySelector('textarea[name="custom#comments"]') ||
                shadow.querySelector('textarea._textArea_17mgw_1');
            const commentDiv = commentTextarea ? commentTextarea.closest('._formFieldContainer_1mxsl_5') : null;
            const submitBtn = shadow.querySelector('._formSubmitButton_cit2d_96');
            const disclaimer = shadow.querySelector('._formDisclaimer_cit2d_38');
            const nextBtn = document.createElement('button');
            nextBtn.type = 'button';
            nextBtn.innerText = 'Next';
            nextBtn.className = 'next-step-btn';
            const form = shadow.querySelector('form');
            if (form) {
                step1Fields.forEach((f) => step2Wrapper.appendChild(f));
                step2Wrapper.appendChild(nextBtn);
                if (uploadDiv) step3Wrapper.appendChild(uploadDiv);
                if (commentDiv) step3Wrapper.appendChild(commentDiv);
                if (submitBtn) step3Wrapper.appendChild(submitBtn);
                if (disclaimer) step3Wrapper.appendChild(disclaimer);
                const finalSkipWrap = document.createElement('div');
                finalSkipWrap.className = 'final-skip-step';
                finalSkipWrap.innerHTML = `
        <p>No photos to upload? No problem!</p>
        <button type="button" class="next-step-btn confirm-final-submit" style="margin: 0 auto !important; min-width: 250px;">
            Confirm & Submit Application
        </button>
        <a href="javascript:void(0)" class="go-back-to-upload" style="display:block; margin-top:15px; font-size:13px; color: #808080;">
            Go back to upload photos
        </a>
        `;
                step3Wrapper.appendChild(finalSkipWrap);
                if (disclaimer) {
                    disclaimer.addEventListener('click', function (e) {
                        e.preventDefault();
                        const heading = shadow.querySelector('h2._textHeading_2aowh_35');
                        const subHeading = shadow.querySelector('._textBody_2aowh_10');
                        if (heading) {
                            heading.innerText = 'Sketches and photos';
                            heading.style.setProperty('display', 'block', 'important');
                            heading.classList.remove('jt-hide-important');
                        }
                        if (subHeading) subHeading.style.setProperty('display', 'none', 'important');
                        if (uploadDiv) uploadDiv.style.setProperty('display', 'none', 'important');
                        if (commentDiv) commentDiv.style.setProperty('display', 'none', 'important');
                        if (submitBtn) submitBtn.style.setProperty('display', 'none', 'important');
                        disclaimer.style.setProperty('display', 'none', 'important');
                        finalSkipWrap.style.setProperty('display', 'block', 'important');
                    });
                }
                const goBackLink = finalSkipWrap.querySelector('.go-back-to-upload');
                if (goBackLink) {
                    goBackLink.onclick = () => {
                        finalSkipWrap.style.display = 'none';
                        const heading = shadow.querySelector('h2._textHeading_2aowh_35');
                        const subHeading = shadow.querySelector('._textBody_2aowh_10');
                        if (heading) heading.style.display = 'block';
                        if (subHeading) subHeading.style.display = 'block';
                        if (uploadDiv) uploadDiv.style.display = 'block';
                        if (commentDiv) commentDiv.style.display = 'block';
                        if (submitBtn) submitBtn.style.display = 'flex';
                        if (disclaimer) disclaimer.style.display = 'block';
                    };
                }
                const confirmBtn = finalSkipWrap.querySelector('.confirm-final-submit');
                if (confirmBtn) {
                    confirmBtn.onclick = () => {
                        if (submitBtn) {
                            //   submitBtn.click(); 
                            const form = shadow.querySelector('form');
                            if (form) {
                                form.requestSubmit();
                            }
                        }
                    };
                }
                const fileInput = step3Wrapper.querySelector('input[type="file"]');
                const uploadField = step3Wrapper.querySelector('._formFileInputField_ehvsf_5');
                if (fileInput) {
                    fileInput.addEventListener('change', () => {
                        if (fileInput.files.length > 0) {
                            if (uploadField) {
                                uploadField.style.border = '1px dashed #cccccc';
                            }
                            const errorMessage = uploadField.nextElementSibling;
                            if (errorMessage && errorMessage.classList.contains('_formError_1mxsl_21')) {
                                errorMessage.remove();
                            }
                        }
                    });
                }
                form.prepend(step2Wrapper);
                form.appendChild(step3Wrapper);
                step1Fields.forEach((container) => {
                    const input = container.querySelector('input');
                    const selectBtn = container.querySelector('button');
                    if (input) {
                        input.addEventListener('input', () => {
                            if (input.value.trim() !== '') {
                                input.style.border = '';
                                const error = container.querySelector('.custom-error-msg');
                                if (error) error.remove();
                            }
                        });
                    }
                    if (selectBtn) {
                        const observer = new MutationObserver(() => {
                            const span = container.querySelector('._selectToggleText_12thd_25');
                            if (span && span.textContent.trim() !== '') {
                                selectBtn.style.border = '';
                                const error = container.querySelector('.custom-error-msg');
                                if (error) error.remove();
                            }
                        });
                        observer.observe(container, { subtree: true, characterData: true, childList: true });
                    }
                });
            }
            nextBtn.addEventListener('click', () => {
                let isValid = true;

                shadow.querySelectorAll('.custom-error-msg').forEach((el) => el.remove());

                const validateEmail = (email) => {
                    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
                };

                step1Fields.forEach((container) => {
                    let fieldInvalid = false;
                    let errorMessage = 'This field is required'; 

                    const input = container.querySelector('input');
                    const selectSpan = container.querySelector('._selectToggleText_12thd_25');
                    const selectBtn = container.querySelector('button');

                    if (input) {
                        const val = input.value.trim();

                        if (val === '') {
                            fieldInvalid = true;
                            input.style.border = '1px solid #ff0000';
                        }
                        else if (input.id === 'email') {
                            if (!validateEmail(val)) {
                                fieldInvalid = true;
                                errorMessage = 'Please enter a valid email address';
                                input.style.border = '1px solid #ff0000';
                            } else {
                                input.style.border = '';
                            }
                        } else {
                            input.style.border = '';
                        }
                    }

                    if (selectSpan && selectSpan.textContent.trim() === '') {
                        fieldInvalid = true;
                        if (selectBtn) selectBtn.style.border = '1px solid #ff0000';
                    } else if (selectBtn) {
                        selectBtn.style.border = '';
                    }

                    if (fieldInvalid) {
                        isValid = false;
                        const errorMsg = document.createElement('span');
                        errorMsg.className = 'custom-error-msg';
                        errorMsg.innerText = errorMessage;
                        errorMsg.style.cssText =
                            'color: #ff0000; font-size: 12px; margin-top: 5px; display: block; text-align: left;';
                        container.appendChild(errorMsg);
                    }
                });

                if (isValid) {
                    step2Wrapper.style.setProperty('display', 'none', 'important');
                    step3Wrapper.style.setProperty('display', 'grid', 'important');
                    const heading = shadow.querySelector('h2._textHeading_2aowh_35');
                    const subHeading = shadow.querySelector('._textBody_2aowh_10');
                    if (heading) {
                        heading.innerText = 'Sketches and photos';
                        heading.style.setProperty('margin-bottom', '0', 'important');
                    }
                    if (subHeading) {
                        subHeading.innerText = 'Show us how you want your design to look.';
                    }
                }
            });
        }
        const observerInner = new MutationObserver(() => {
            const spans = shadow.querySelectorAll('._selectToggleText_12thd_25');
            spans.forEach((span) => {
                if (span.textContent.trim() !== '') {
                    span.classList.add('has-value');
                } else {
                    span.classList.remove('has-value');
                }
            });
            wrapErrorFields(shadow);
        });
        observerInner.observe(shadow, {
            childList: true,
            subtree: true,
            characterData: true,
        });
    }
    const observer = new MutationObserver(() => {
        const embed = document.querySelector('shopify-forms-embed');
        if (embed && embed.shadowRoot) {
            initShopifyFormFix();
        }
    });
    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });
});